/*
*@Author: dcl
*@Description: 客户服务及投诉举报页面
*@Date: 2022-11-14 11:25:08
*/
<template>
<div class="icom">
    <div class="icom-box">
        <!-- <el-image class="box_img" :src="info_plain1" /> -->
        <div class="box-pot">
            <div class="pot-step">STEP</div>
            <div class="pot-number">01</div>
        </div>
        <div class="box-title box-title1">投保咨询和保单查询、验真及电子保单下截</div>
        <div class="box-txt">您可拔打东风南方保险代理有限公司咨询电话：020-36878670或拟投保保险公司客服电话进行投保咨询；</div>
        <div class="box-txt">关于您投保的保单，如您需要查询和验真，您可通过登陆承保保险公司官网、拔打保险公司客服电话或登陆金融产品查询平台官网进行查询。</div>
        <div class="box-txt">本平台合作保险公司电子保单下截地址：</div>
        <!-- <div class="box-txt">
            中国人民财产保险股份有限公司：
            <a href="https://www.picc.com/servicecenter/" target="_blank">https://www.picc.com/servicecenter/</a>
        </div> -->
        <div class="box-txt">
            中国平安财产保险股份有限公司：
            <a href="https://www.4008000000.com/" target="_blank">https://www.4008000000.com/</a>
        </div>
        <div class="box-txt">
            中国大地财产保险股份有限公司：
            <a href="https://mo.95590.cn/view/serviceKind/elePolicyDownload.html" target="_blank">https://mo.95590.cn/view/serviceKind/elePolicyDownload.html</a>
        </div>
        <div class="box-txt">
            金融产品查询平台官网：
            <a href="https://www.jrcpcx.cn" target="_blank">https://www.jrcpcx.cn</a>
        </div>
    </div>
    <div class="icom-box">
        <!-- <el-image class="box_img" :src="info_plain2" /> -->
        <div class="box-pot">
            <div class="pot-step">STEP</div>
            <div class="pot-number">02</div>
        </div>
        <div class="box-title box-title2">理赔服务</div>
        <div class="box-txt">如您的保单涉及理赔服务，您可通过东风南方保代官网查询各承保公司联系电话，咨询保险公司客服理赔争议处理机制和工作流程；</div>
        <div class="box-txt">如您对保单理赔结果存在异议，亦请咨询承保公司客服。</div>
    </div>
    <div class="icom-box">
        <!-- <el-image class="left_img" :src="info_plain3" /> -->
        <div class="box-pot">
            <div class="pot-step">STEP</div>
            <div class="pot-number">03</div>
        </div>
        <div class="box-title box-title2">联系我们</div>
        <div class="box-txt">通讯地址：广州市花都区风神大道11号之八二楼</div>
        <div class="box-txt">电子邮箱：zhangshujuan@dfl.com.cn</div>
        <div class="box-txt">客服、投诉热线：020-36878670 （8:30-17:30）</div>
        <div class="box-txt">
            消费投诉处理流程：
            <!-- <div class="txt-title"></div> -->
            <div class="flow">
                <div class="txt">客户投诉</div>
                <div class="pot"></div>
                <div class="txt">
                    <div>询问信息</div>
                    <div>受理投诉</div>
                </div>
                <div class="pot"></div>
                <div class="txt">
                    <div>联系客户</div>
                    <div>调查核实</div>
                </div>
                <div class="pot"></div>
            </div>
            <div class="flow">
                <div class="txt">
                    <div>10个工作日</div>
                    <div>反馈结果</div>
                </div>
                <div class="line1"></div>
                <div class="line2">
                    <div class="lineTxt1">达成一致意见</div>
                    <div class="lineTxt2">未达成一致意见</div>
                </div>
                <div>
                    <div class="lineto">
                        <div class="pot pot1"></div>
                        <div class="txt">结案</div>
                    </div>
                    <div class="lineto">
                        <div class="pot pot2"></div>
                        <div class="txt">调解、仲裁、诉讼</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="box-right">
            <div class="right-title">消费投诉处理流程：</div>
            <el-image class="right_img" :src="info_plain4" />
        </div> -->
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            info_plain1: require("../../assets/info_plain1.jpg"),
            info_plain2: require("../../assets/info_plain2.jpg"),
            info_plain3: require("../../assets/info_plain3.jpg"),
            info_plain4: require("../../assets/info_plain4.jpg")
        }
    }
};
</script>

<style lang="less" scoped>
.icom {
    margin: 0px 12px;
    font-size: 1rem;
    padding-bottom: 3.2rem;

    .icom-box {
        margin-top: 12px;

        .box_img {
            width: 2.27rem;
            height: 0.93rem;
        }

        .box-pot {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            font-size: 0.6rem;
            color: #4B65B3;

            .pot-number {
                font-size: 0.8rem;
                font-weight: bold;
                line-height: 0.8rem;
            }
        }

        .box-title {
            font-weight: bold;
            line-height: 1.1rem;
            height: 1.1rem;
            background-image: linear-gradient(#FFFFFF, #FFF1DD);
            font-size: .8rem;
        }

        .box-title1 {
            width: 15.33rem;
            margin-bottom: .63rem;
        }

        .box-title2 {
            width: 3.2rem;
            margin-bottom: .63rem;
        }

        .box-txt {
            font-size: 0.53rem;
            line-height: 1.33rem;

            .flow {
                display: flex;
                flex-direction: row;
                align-items: center;
                text-align: center;
                font-size: 0.47rem;
                margin-bottom: 1rem;

                .txt {
                    padding: 0.2rem;
                    // height: 40px;
                    line-height: 0.8rem;
                    background-color: #ebf3ff;
                    border: 1px solid #79b0ff;
                    border-radius: 0.1rem;
                }

                .pot {
                    margin: 0px 0.3rem;
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-left: 6px solid #1576ff;
                }

                .line1 {
                    margin: 0px 0.33rem;
                    width: 0.9rem;
                    height: 0.9rem;
                    // background-color: #1576FF;
                    border-left: 1px solid #1576ff;
                    border-bottom: 1px solid #1576ff;
                    transform-origin: center;
                    transform: rotate(45deg);
                }

                .line2 {
                    width: 90px;
                    height: 1.2rem;
                    border-top: 1px solid #1576ff;
                    border-bottom: 1px solid #1576ff;
                    margin-left: -0.85rem;
                    position: relative;
                    color: #acacac;

                    .lineTxt1 {
                        position: absolute;
                        top: -1.1rem;
                        left: 0rem;
                        font-size: 8px;
                        // transform: scale(0.666);
                        // transform-origin: 0 0;
                    }

                    .lineTxt2 {
                        position: absolute;
                        top: 1.1rem;
                        left: 0rem;
                    }

                    // margin-top: 3px;
                }

                .lineto {
                    display: flex;
                    flex-direction: row;
                    margin: 0.1rem 0px;

                    .pot1 {
                        margin: 0.42rem 0 0 0;
                    }

                    .pot2 {
                        margin: 0.32rem 0 0 0;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Informationmobile/complain.vue